// =============================================
// محتوى المساعدة + خطوات الجولة التفاعلية
// كل خطوة جولة تشير إلى عنصر بـ data-tour="key" في الـ DOM
// =============================================

export const tourSteps = [
  {
    target: '[data-tour="welcome"]',
    title: '👋 مرحباً بك في منصّة العمليات',
    body: 'هذه جولة سريعة (دقيقة واحدة) تعرّفك على الأقسام الرئيسية. تستطيع تخطّيها وإعادة تشغيلها متى شئت من زرّ "؟" في الأعلى.',
    placement: 'center',
  },
  {
    target: '[data-tour="nav-dashboard"]',
    title: '📊 لوحة التحكّم',
    body: 'نظرة سريعة: عدد المهام النشطة، المتأخرة، التي بانتظار الاعتماد، وآخر النشاطات. ابدأ يومك من هنا.',
    placement: 'left',
  },
  {
    target: '[data-tour="nav-tasks"]',
    title: '📋 المهام',
    body: 'إدارة كاملة للمهام بثلاث طرق عرض: قائمة تفصيلية، Kanban بالسحب والإفلات، وتقويم شهري. تستطيع تتبّع الوقت المسجّل لكل مهمة.',
    placement: 'left',
  },
  {
    target: '[data-tour="nav-projects"]',
    title: '📂 المشاريع',
    body: 'تجميع المهام تحت مشاريع لكل عميل، مع شريط تقدّم وإحصائيات. مفيد للمشاريع الطويلة متعدّدة المراحل.',
    placement: 'left',
  },
  {
    target: '[data-tour="nav-workflows"]',
    title: '🔄 المسارات',
    body: 'قوالب عمل مرسومة كمراحل: المراحل تتوالى، وخطوات المرحلة الواحدة تعمل متوازية. عند إنشاء مهمة من مسار، تتولّد خطواته تلقائياً وتنتقل بين المسؤولين.',
    placement: 'left',
  },
  {
    target: '[data-tour="nav-recurring"]',
    title: '🔁 مهام متكرّرة',
    body: 'قوالب لمهام تتكرّر يومياً/أسبوعياً/شهرياً. مثلاً: "مونتاج درس الجمعة" يتولّد تلقائياً كل أسبوع مع رقم متسلسل.',
    placement: 'left',
  },
  {
    target: '[data-tour="nav-transcription"]',
    title: '🎙️ التفريغ الصوتي',
    body: 'ارفع ملف صوتي أو رابط يوتيوب → يُفرَّغ نصياً عبر Groq Whisper بتنسيق إسلامي تلقائي. مدعوم بـ LLama لتحرير النتيجة.',
    placement: 'left',
  },
  {
    target: '[data-tour="nav-reports"]',
    title: '📈 التقارير',
    body: 'تقارير أداء الفريق، حالة العملاء، نقاط الاختناق في المسارات، والمتأخّرات. كلها قابلة للتصدير CSV.',
    placement: 'left',
    roles: ['admin'],
  },
  {
    target: '[data-tour="topbar-help"]',
    title: '❓ زرّ المساعدة',
    body: 'هنا تستطيع إعادة تشغيل هذه الجولة، أو فتح مركز المساعدة الكامل بالبحث في كل المواضيع. جاهز لتبدأ؟',
    placement: 'bottom',
  },
];

// =============================================
// جولات خاصة بكل صفحة — تظهر عند الضغط على زرّ ❓ من تلك الصفحة
// المفتاح pathname (يدعم * للمطابقة بالبادئة)
// =============================================
export const pageTours = {
  '/book-summaries': [
    {
      target: '[data-tour="books-create"]',
      title: '📚 كتاب جديد',
      body: 'أضف الكتاب هنا، ثم كلّف الباحث من صفحته بمهلة محدّدة. وقبل ذلك أضف الباحثين ولجنة المراجعة من «فريق العمل» — بأسمائهم فقط ولو لم يكن لهم حساب في المنصّة.',
      placement: 'bottom',
    },
    {
      target: '[data-tour="books-table"]',
      title: 'مسار كل كتاب',
      body: 'كل صفّ يُظهر المرحلة الحالية ومن يمسك الملف ومهلته. المهلة الحمراء تعني تأخّراً، وعمود «معلّق» يعدّ الملاحظات التي ستُرفق بالملف النهائي.',
      placement: 'top',
    },
  ],
  '/': [
    {
      target: '[data-tour="dashboard-stats"]',
      title: '📊 بطاقات الإحصائيات',
      body: 'نظرة سريعة على المهام النشطة، المتأخّرة، التي بانتظار اعتماد، والمنجَزة اليوم/الأسبوع.',
      placement: 'bottom',
    },
    {
      target: '[data-tour="dashboard-recent-tasks"]',
      title: 'المهام الأخيرة',
      body: 'آخر ١٠ مهام نشطة مرتّبة بالأولوية وموعد التسليم. اضغط مهمة لفتح تفاصيلها.',
      placement: 'top',
    },
    {
      target: '[data-tour="dashboard-recent-logs"]',
      title: 'آخر النشاطات',
      body: 'سجلّ آخر ١٥ تغييراً في المنصّة (إنشاء/تحديث/تعليق/اعتماد).',
      placement: 'top',
    },
  ],
  '/tasks': [
    {
      target: '[data-tour="tasks-view-modes"]',
      title: 'أوضاع العرض',
      body: 'بدّل بين قائمة (جدول)، Kanban (سحب وإفلات)، وتقويم شهري. اختيارك يُحفَظ.',
      placement: 'bottom',
    },
    {
      target: '[data-tour="tasks-filters"]',
      title: 'الفلترة المتقدّمة',
      body: 'بحث نصّي، حالة، أولوية، عميل/مشروع، تاريخ من/إلى، وسم. زرّ "✕" يمسح الكل.',
      placement: 'bottom',
    },
    {
      target: '[data-tour="tasks-create"]',
      title: 'إنشاء مهمة',
      body: 'افتح نموذج إنشاء مهمة جديدة. تستطيع ربطها بمسار يولّد خطواته الفرعية تلقائياً.',
      placement: 'left',
    },
  ],
  '/projects': [
    {
      target: '[data-tour="projects-create"]',
      title: 'مشروع جديد',
      body: 'أنشئ مشروعاً تحت عميل معيّن — يجمع المهام ويظهر شريط تقدّم تلقائياً.',
      placement: 'left',
    },
    {
      target: '[data-tour="projects-grid"]',
      title: 'بطاقات المشاريع',
      body: 'كل بطاقة تعرض التقدّم (المنجَز/الإجمالي + نسبة). اضغطها لرؤية مهامها.',
      placement: 'top',
    },
  ],
  '/recurring-tasks': [
    {
      target: '[data-tour="recurring-create"]',
      title: 'قالب جديد',
      body: 'أنشئ قالباً يولّد مهاماً يومياً/أسبوعياً/شهرياً. استخدم {n} في العنوان للعدّاد التلقائي.',
      placement: 'left',
    },
  ],
  '/workflows': [
    {
      target: '[data-tour="workflows-create"]',
      title: 'مسار جديد',
      body: 'ارسم مسار عمل من مراحل متتالية، وأضف داخل المرحلة خطوات متوازية. يستخدمه أي مهمة لاحقاً.',
      placement: 'left',
    },
    {
      target: '[data-tour="workflows-list"]',
      title: 'إدارة المسارات',
      body: 'عدّل الخطوات وأعد ترتيب المراحل وحدّد متطلبات كل خطوة، أو حوّل المسار لغير نشط (لا يمكن حذفه إذا كان مستخدماً).',
      placement: 'top',
    },
  ],
  '/transcription': [
    {
      target: '[data-tour="transcription-upload"]',
      title: 'رفع ملف صوتي',
      body: 'mp3 / wav / m4a / ogg / webm حتى 100MB، أو الصق رابط يوتيوب. التفريغ بتنسيق إسلامي.',
      placement: 'bottom',
    },
  ],
  '/reports': [
    {
      target: '[data-tour="reports-tabs"]',
      title: 'أنواع التقارير',
      body: 'أداء الفريق، حالة العملاء، المتأخّرات، اختناقات المسارات.',
      placement: 'bottom',
    },
    {
      target: '[data-tour="reports-export"]',
      title: 'التصدير',
      body: 'CSV (يفتح في Excel بعربية سليمة) أو PDF (طباعة من المتصفّح).',
      placement: 'left',
    },
  ],
  '/help': [
    {
      target: '[data-tour="help-search"]',
      title: '🔍 البحث',
      body: 'يبحث في عناوين المقالات، الكلمات المفتاحية، والمحتوى الكامل. النتائج تتحدّث فوراً مع التمييز.',
      placement: 'bottom',
    },
    {
      target: '[data-tour="help-cats"]',
      title: 'التصنيفات',
      body: 'فلتر سريع حسب الموضوع.',
      placement: 'bottom',
    },
  ],
  '/clients': [
    {
      target: '[data-tour="clients-create"]',
      title: 'عميل جديد',
      body: 'أضف عميلاً (شيخ، مؤسسة مانحة، أو غيرها) لربط مشاريعه ومهامه.',
      placement: 'left',
    },
  ],
  '/users': [
    {
      target: '[data-tour="users-create"]',
      title: 'مستخدم جديد',
      body: 'أضف عضو فريق أو حساب عميل بدور محدّد (admin / team / client).',
      placement: 'left',
    },
  ],
  '/settings': [
    {
      target: '[data-tour="settings-groq"]',
      title: 'مفتاح Groq API',
      body: 'يُستخدم لتفريغ الصوت. يُحفَظ مشفّراً في قاعدة البيانات ويبقى بين كل التحديثات.',
      placement: 'bottom',
    },
  ],
};

// Pick the best matching page tour for a given pathname
export function getPageTour(pathname) {
  if (pageTours[pathname]) return pageTours[pathname];
  // Match prefix (e.g. /tasks/123 → /tasks)
  const match = Object.keys(pageTours)
    .filter(p => p !== '/' && pathname.startsWith(p))
    .sort((a, b) => b.length - a.length)[0];
  return match ? pageTours[match] : null;
}

// =============================================
// مقالات مركز المساعدة (قابلة للبحث)
// =============================================
export const helpArticles = [
  {
    id: 'book-summaries',
    category: 'سير العمل',
    title: 'تلخيص الكتب: من التكليف إلى الاعتماد',
    keywords: ['تلخيص', 'كتب', 'باحث', 'مراجعة', 'لجنة', 'ملاحظات', 'معلّق', 'اعتماد'],
    content: `
سير ملف تلخيص الكتاب أربع مراحل، لكل واحدة **مهلة** ومن يمسك الملف فيها:

1. **قيد التلخيص** — الباحث المكلَّف يرفع «نسخة الباحث».
2. **قيد المراجعة** — مراجع من لجنة المراجعة يُقيّد بنوده المرقّمة.
3. **قيد تعديل الملاحظات** — الملف يعود للباحث، يعلّم كل بند بأنه «عُدِّل».
4. **بانتظار الاعتماد** — المشرف العام يعتمد، أو يُرجع الملف فتُفتح جولة جديدة.

**الجولات تتكرّر بلا حدّ**: كل ذهاب-وعودة جولة مستقلّة محفوظة بتواريخها، فتاريخ
الكتاب كامل ولو راجعه ثلاثة مراجعين في ثلاث جولات.

**حالات بنود الملاحظات:** جديد ← عُدِّل ← مقبول، أو **معلّق** للبند الذي لم
يُحسم. والاعتماد محجوب ما بقي بندٌ «جديد» لم يُنظر فيه، والبنود المعلّقة تلزم
إقراراً صريحاً من المشرف — وهي ما يُرفق مع الملف العام (ارفع ملفها في «ملف
الملاحظات المعلّقة» قبل الاعتماد).

**العمل بلا حسابات للفريق:** أضف الباحثين والمراجعين من «فريق العمل» بأسمائهم
فقط، وسجّل أنت كل خطوة نيابةً عنهم. ومتى أُعطي أحدهم حساباً في المنصّة، اربطه
باسمه من الجدول نفسه — فيُنسب إليه كل عمله السابق ويرى تاريخ كتبه فوراً، بلا
أي تعديل آخر.

**التقرير الشهري** من زرّ «التقرير الشهري»: مصفوفة الكتب × المراحل، وتفصيل كل
كتاب، وأداء الفريق، وملحق بالبنود المعلّقة — وله نسخة للطباعة.
`,
  },
  {
    id: 'getting-started',
    category: 'البدء',
    title: 'البدء بسرعة',
    keywords: ['بدء', 'تسجيل', 'دخول', 'أول مرة'],
    content: `
بعد تسجيل الدخول لأول مرة، تعرض لك المنصّة جولة قصيرة تستعرض الأقسام الرئيسية.

**الخطوات الأولى المقترحة:**
1. غيّر كلمة المرور من شريط الملف الشخصي
2. تحقّق من قائمة العملاء في "العملاء" — أضف الناقصين منهم
3. أنشئ أوّل مسار عمل من "المسارات" (مثلاً: مونتاج فيديو من ٣ خطوات)
4. أنشئ أوّل مهمة من "المهام" — اختر العميل والمسار
5. تابع التقدّم من لوحة التحكّم

**أدوار المستخدمين:**
- **مدير**: صلاحيات كاملة (إنشاء، تعديل، حذف، تقارير، إعدادات، صفحات عرض)
- **عضو فريق**: إنشاء وتعديل المهام والمشاريع المسنّدة إليه
- **عميل**: عرض مشاريعه ومهامّه فقط، اعتماد المخرجات، إضافة ملاحظات
    `,
  },
  {
    id: 'client-portal',
    category: 'بوابة العميل',
    title: 'بوابة العميل وطريقة الدخول',
    keywords: ['بوابة', 'عميل', 'دخول', 'تذكرة', 'تذاكر', 'طلبات', 'رسائل', 'portal', 'support', 'login', 'كلمة المرور'],
    content: `
بوابة العميل مساحة مستقلّة يدخلها العميل ليتابع أعماله ويفتح تذاكره دون رؤية بيانات باقي العملاء أو لوحة الفريق.

**كيف يُنشأ حساب العميل:**
1. من صفحة **العملاء** أضف عميلاً وأدخل بريده في حقل "البريد الإلكتروني (لبوابة العميل)"
2. اكتب **كلمة مرور حساب البوابة** (٨ أحرف فأكثر) وسلّمها للعميل بأمان
3. إن تركت الحقل فارغاً وصل العميل رابطاً بالبريد ليعيّن كلمة المرور بنفسه (صالح أسبوعاً)
4. عمود **حساب البوابة** في الجدول يبيّن إن كان الملفّ مرتبطاً بحساب؛ وزرّ **ربط** يعالج ملفّاً غير مرتبط ببريد مسجّل

**طريقة الدخول:**
1. رابط دخول العملاء مستقلّ عن دخول الفريق: **/support**
2. خيار "حفظ الدخول على هذا المتصفح" يُبقي الجلسة بعد إغلاق المتصفّح؛ أوقِفه على الأجهزة المشتركة
3. "نسيت كلمة المرور؟" يرسل رابطاً صالحاً ساعة، ويُبطل الجلسات القائمة بعد التغيير
4. بعد الدخول يُوجَّه إلى بوابته (/portal) — لا يرى أقسام الفريق

**ما يستطيع العميل فعله داخل البوابة:**
- **تذاكري**: فتح تذكرة (عنوان، تفاصيل، أولوية، ومشروع مطلوب متى كانت له مشاريع)، ومتابعة حالتها: قيد المراجعة ← جارٍ العمل ← مُنجزة ← مغلقة (أو معتذَر عنها)
- **المرفقات**: رفع ملفات ضمن حدود المساحة (١٠MB للملف، ٢٥MB للتذكرة، ٢٥٠MB للحساب)، أو مشاركة رابط من قوقل درايف/ون درايف للملفات الكبيرة
- **بعد الإنجاز**: تأكيد الاستلام فتُغلق التذكرة، أو طلب تعديل فتُعاد للعمل. وإن لم يردّ خلال **يوم عمل واحد** أُغلقت تلقائياً
- **مشاريعي**: مشاريعه وتقدّم مهامها
- **المهام**: اعتماد المخرجات بانتظار اعتماده أو طلب تعديل، وإضافة ملاحظات
- **الرسائل**: مراسلة مباشرة مع الفريق، ويصل إشعار بالبريد لكل رسالة

**من طرف الفريق:**
- تصل التذاكر الجديدة إلى صفحة **طلبات العملاء**، ويحوّلها من يملك صلاحية "معالجة الطلبات" إلى مهمة تُسند لمختص عبر نظام المهام/المسارات
- مراسلة العميل من صفحة **العملاء** ← زرّ 💬 (تتطلّب صلاحية "تعديل العملاء")
- عند إنجاز المهمة يصل العميل إشعار تلقائي عبر القنوات المفعّلة لديه (داخل التطبيق + بريد + تيليجرام + واتساب)
    `,
  },
  {
    id: 'tasks',
    category: 'المهام',
    title: 'إدارة المهام',
    keywords: ['مهام', 'مهمة', 'kanban', 'تقويم', 'وقت', 'تتبّع'],
    content: `
**ثلاث طرق عرض:**
- **قائمة**: جدول تفصيلي بالعمود الزمني والوقت المسجّل
- **Kanban**: لوحة بأعمدة الحالات — اسحب البطاقات بين الأعمدة لتغيير الحالة
- **تقويم**: عرض شهري بمواعيد التسليم ملوّنة بالأولوية

**حقول المهمة:**
- العنوان، الوصف، الأولوية (منخفضة/متوسطة/عالية/عاجلة)
- المسؤول، العميل، المشروع، المسار
- موعد التسليم، الوقت المقدَّر بالدقائق، الوسوم
- جدولة مستقبلية (تظهر بعد تاريخ معيّن)

**تتبّع الوقت:**
في صفحة تفاصيل المهمة، أضف دقائق مع ملاحظة. شريط تقدّم يقارن المسجَّل بالمقدَّر، يتحوّل أحمر عند التجاوز.

**الفلترة المتقدّمة:**
بحث، حالة (متعدّد)، أولوية، عميل، مشروع، تاريخ من/إلى، وسم، "أنا فقط"، المتأخّرة فقط.
    `,
  },
  {
    id: 'projects',
    category: 'المشاريع',
    title: 'المشاريع',
    keywords: ['مشروع', 'مشاريع', 'تقدّم'],
    content: `
المشروع تجميعة مهام تحت عميل واحد، مع شريط تقدّم وإحصائيات (المنجَز/الإجمالي).

**العمليات:**
- إنشاء/تعديل (مدير وفريق)
- حذف (مدير فقط — والمشروع لا يحوي مهام)
- أرشفة بدلاً من الحذف للمشاريع المكتملة

اضغط على بطاقة المشروع → يفتح قائمة المهام مفلترة لهذا المشروع.
    `,
  },
  {
    id: 'workflows',
    category: 'المسارات',
    title: 'مسارات العمل',
    keywords: ['مسار', 'مسارات', 'workflow', 'خطوات', 'اعتماد', 'مراحل', 'متوازية', 'تفرّع'],
    content: `
المسار قالب عمل مرسوم. عند إنشاء مهمة من مسار، تتولّد كل خطوة كمهمة فرعية مرتبطة.

**رسم المسار (مراحل):**
- المسار سلسلة **مراحل** تُنفَّذ بالتتابع
- خطوات المرحلة الواحدة **متوازية**: تُفتح معاً ويعمل عليها أكثر من شخص في وقت واحد
- المرحلة التالية تبدأ بعد اكتمال كل خطوات المرحلة السابقة

**أنواع الخطوات:**
- **مهمة**: عمل عادي (مكلَّف بمسؤول)
- **اعتماد**: تنتظر موافقة شخص محدّد

**متطلبات مخصّصة:**
تستطيع لخطوة معيّنة اختيار متطلباتها يدوياً من خطوات المراحل السابقة بدل انتظار المرحلة كلها، وتحديد أتبدأ بعد اكتمال **كل** متطلباتها أم بعد **أوّل** متطلب يكتمل (الخطوات الموازية الباقية تبقى عملاً قائماً).

**التقدّم التلقائي:**
عند إكمال خطوة → تُفتح كل خطوة استوفت متطلباتها تلقائياً من "بانتظار" إلى "قيد العمل" + إشعار للمسؤول. وتُغلق المهمة الأم عند اكتمال كل خطواتها.

**التحرير من لوحة التحكّم:**
المدير يرسم المسار من /workflows: إضافة مرحلة تالية، إضافة خطوة موازية داخل مرحلة، ونقل الخطوات بين المراحل.
    `,
  },
  {
    id: 'recurring',
    category: 'المهام المتكرّرة',
    title: 'المهام المتكرّرة',
    keywords: ['متكرّر', 'دوري', 'أسبوعي', 'شهري', 'cron'],
    content: `
قوالب تولّد مهاماً تلقائياً بتردّد محدّد:
- **يومي** — كل يوم في وقت محدّد
- **أسبوعي** — يوم من الأسبوع (الأحد..السبت)
- **شهري** — يوم من الشهر (1..31)

**العنوان كقالب:**
استخدم \`{n}\` للعدّاد. مثلاً: "مونتاج الدرس {n}" يصبح "مونتاج الدرس 41" تلقائياً.

**التشغيل:**
يعمل دون cron — يُحفَّز عند زيارات API بمعدّل ~1 مرة/دقيقة عبر middleware آمن من التزامن (Cache lock).
    `,
  },
  {
    id: 'transcription',
    category: 'التفريغ',
    title: 'التفريغ الصوتي',
    keywords: ['تفريغ', 'صوت', 'whisper', 'youtube', 'mp3'],
    content: `
**المدخلات المدعومة:**
- ملفات صوتية (mp3, wav, m4a, ogg, flac, webm) حتى 100MB
- روابط يوتيوب (يُحمَّل الصوت تلقائياً)

**المخرَج:**
نص مفرَّغ بتنسيق إسلامي (تشكيل دقيق على المصطلحات، فواصل عند آيات القرآن، تصحيح الأسماء).

**التقنية:**
- Groq Whisper Large v3 للتفريغ الأوّلي
- GPT-OSS 120B (عبر Groq) لتحرير النصّ وضبط التنسيق

**الإعدادات:**
المدير يستطيع تغيير مفتاح Groq API من /settings.
    `,
  },
  {
    id: 'reports',
    category: 'التقارير',
    title: 'التقارير',
    keywords: ['تقرير', 'تقارير', 'CSV', 'PDF', 'أداء'],
    content: `
**التقارير المتاحة (مدير فقط):**
1. **أداء الفريق** — لكل عضو: المنجَز، النشط، المتأخّر، متوسط أيام إنجاز المهمة
2. **حالة العملاء** — لكل عميل: عدد المشاريع، المهام النشطة، المعتمَدة، المنتظرة
3. **المتأخّرات** — كل المهام التي تجاوزت موعد التسليم، مرتّبة بأيام التأخّر
4. **اختناقات المسارات** — الخطوات التي يبقى فيها المتوسط أكثر من يومين

**التصدير:**
- CSV (يفتح في Excel بعربية سليمة عبر BOM)
- PDF (طباعة من المتصفّح)
    `,
  },
  {
    id: 'notifications',
    category: 'التنبيهات',
    title: 'التنبيهات',
    keywords: ['تنبيه', 'إشعار', 'notification'],
    content: `
شارة الجرس في أعلى يمين الشاشة تُظهر عدد التنبيهات غير المقروءة.

**أنواع التنبيهات:**
- إسناد مهمة جديدة لك
- انتقال خطوة في المسار إلى دورك
- مهمة بانتظار اعتمادك (للعميل)

**التحديث الذكي:**
يفحص كل 10 ثوانٍ في النشاط، 30 في الخمول، 120 عند إخفاء النافذة — لتوفير الموارد.
    `,
  },
  {
    id: 'shortcuts',
    category: 'مفاتيح وأسرار',
    title: 'اختصارات ونصائح',
    keywords: ['اختصار', 'نصيحة', 'تحايل'],
    content: `
- **Dark Mode**: زرّ القمر/الشمس في الأعلى — الإعداد محفوظ في المتصفّح
- **Sidebar**: اضغط السهم لطيّ القائمة (مفيد على الشاشات الصغيرة)
- **مسح الفلاتر**: زرّ "✕" في شريط الفلترة بالمهام (يظهر إذا كانت الفلاتر مفعّلة)
- **حفظ وضع العرض**: آخر اختيار (قائمة/Kanban/تقويم) محفوظ تلقائياً
- **إعادة الجولة**: من زرّ "؟" في الأعلى → "إعادة الجولة"
- **Sticky search**: حقل البحث في مركز المساعدة يبحث في عناوين ومحتوى المقالات
    `,
  },
];

export const helpCategories = [...new Set(helpArticles.map(a => a.category))];
